import { useContext } from 'react';
import { TApplicationDetailsManager } from 'datasource/useApplicationDetails/ApplicationDetailsManager.types';
import { ApplicationDetailsContext } from './ApplicationDetailsManager';

export const useApplicationDetails = (): TApplicationDetailsManager => useContext(ApplicationDetailsContext);
